module.exports = "pegasus_template/assets/logo.png";